<template>
  <div class="content-wrapper">
    <div class="row">
      <div class="col-12 mb-primary">
        <div class="card card-with-shadow border-0 h-100">
          <div class="card-header p-primary bg-transparent">
            <h5 class="card-title d-inline-block mb-0">
              {{ $t("create_job") }}
            </h5>
            <!-- <div class="float-right">
                        <a href="/buyer/job" class="btn btn-primary btn-sm">Back</a>
                    </div> -->
          </div>
          <app-overlay-loader v-if="preloader" />
          <div class="card-body">
            <form
              class="mb-0"
              :class="{ 'loading-opacity': preloader }"
              ref="form"
              data-url="/admin/comapny/job/store"
            >
              <div class="form-group row">
                <div class="col-sm-6">
                  <label for="inputs_name" >
                    {{ $t("title") }}
                  </label>
                  <app-input
                    id="inputs_name"
                    type="text"
                    v-model="job.title"
                    placeholder="Enter Job Title"
                    :required="true"
                  />
                </div>
                <div class="col-sm-6">
                  <label for="inputs_category" >
                    {{ $t("category") }}
                  </label>
                  <app-input
                    id="inputs_category"
                    type="search-select"
                    :placeholder="$t('select_category')"
                    :required="true"
                    v-model="job.category_id"
                    :list="category"
                  />
                  <p class="font-italic text-muted" v-if="!isHideActions">
                    {{ $t("shortcut_category_create") }} <span><a href="#" @click.prevent="addCategory()">{{$t("add_category")}}</a></span>
                  </p>
                </div>
              </div>
              <div class="form-group row">
                <div class="col-sm-12">
                  <label for="inputs_email">
                    {{ $t("short_description") }}
                  </label>
                  <app-input
                    id="inputs_email"
                    type="textarea"
                    placeholder="Short Description About Job"
                    v-model="job.short_description"
                    :required="true"
                  />
                </div>
                
              </div>
              <div class="form-group row">
                <div class="col-sm-6">
                  <label for="inputs_status">
                  {{ $t("start_date") }}
                  </label>
                  <app-input
                    id="inputs_status"
                    type="date"
                    :required="true"
                    v-model="job.start_date"
                  />
                  <!-- :min-date="new Date()" -->
                </div>
                <div class="col-sm-6">
                  <label for="inputs_status">
                    {{ $t("end_date") }}
                  </label>
                  <app-input
                    id="inputs_status"
                    type="date"
                    :required="true"
                    v-model="job.end_date"
                  />
                </div>
              </div>
              <div class="form-group row">
                <div class="col-sm-4">
                  <label for="inputs_status">
                    {{ $t("bid_range") }}
                  </label>
                    <app-input
                      id="inputs_status"
                      type="text"
                      :required="true"
                      placeholder="Enter Bid Range Amont"
                      v-model="job.bid_range"
                    />
                </div>
                <div class="col-md-2 col-sm-2" style="margin-top: 2rem">
                  <app-input
                    id="inputs_range"
                    type="select"
                    :required="true"
                    v-model="job.range"
                    :list="bidRangeList"
                  />
                  <p class="font-italic text-muted" v-if="!isHideActions">
                    <a href="#" @click.prevent="addDropdown(type='range' )">{{$t("add_bid_range")}}</a>
                  </p>
                </div>
                <div class="col-sm-6">
                  <label for="inputs_status">
                    {{ $t("job_type") }}
                  </label>
                  <app-input
                    id="inputs_status"
                    type="select"
                    :required="true"
                    v-model="job.job_type"
                    :list="jobTypeList"
                  />
                </div>
              </div>
              <div class="form-group row">
                <div class="col-sm-6">
                  <label for="inputs_status">
                  {{ $t("job_status") }}
                  </label>
                  <app-input
                    id="inputs_status"
                    type="select"
                    :required="true"
                    v-model="job.status"
                    :list="status"
                  />
                </div>
                <div class="col-sm-6">
                  <label for="inputs_status">
                    {{ $t("is_private") }}
                  </label>
                  <app-input
                    id="inputs_status"
                    type="select"
                    :required="true"
                    v-model="job.is_private"
                    :list="is_private"
                  />
                </div>
              </div>
              <div class="form-group row">
                <div class="col-sm-6">
                  <label for="region" >
                    {{ $t("region") }}
                  </label>
                  <app-input
                    id="region"
                    type="select"
                    v-model="job.region"
                    :list="regionlist"
                  />
                  <p class="font-italic text-muted" v-if="!isHideActions">
                    {{ $t("shortcut_add_dropdown") }} <span><a href="#" @click.prevent="addDropdown(type='region' )">{{$t("add_region")}}</a></span>
                  </p>
                </div>
                <div class="col-sm-6">
                  <label for="noticetype">
                    {{ $t("notice_type") }}
                  </label>
                  <app-input
                    id="noticetype"
                    type="select"
                    v-model="job.noticetype"
                    :list="noticetypelist"
                  />
                  <p class="font-italic text-muted" v-if="!isHideActions">
                    {{ $t("shortcut_add_dropdown") }} <span><a href="#" @click.prevent="addDropdown(type='notice' )">{{$t("add_notice_type")}}</a></span>
                  </p>
                </div>
              </div>
              <div class="form-group row">
                <div class="col-sm-6">
                  <label for="threshold">
                    {{ $t("threshold") }}
                  </label>
                  <app-input
                    id="threshold"
                    type="select"
                    v-model="job.threshold"
                    :list="threshold"
                  />
                  <p class="font-italic text-muted" v-if="!isHideActions">
                    {{ $t("shortcut_add_dropdown") }} <span><a href="#" @click.prevent="addDropdown(type='threshold' )">{{$t("add_threshold")}}</a></span>
                  </p>
                </div>
                <div class="col-sm-6">
                  <label for="framework">
                    {{ $t("framework") }}
                  </label>
                  <app-input
                    id="framework"
                    type="select"
                    v-model="job.framework"
                    :list="framework"
                  />
                  <p class="font-italic text-muted" v-if="!isHideActions">
                    {{ $t("shortcut_add_dropdown") }} <span><a href="#" @click.prevent="addDropdown(type='framework' )">{{$t("add_frame_work")}}</a></span>
                  </p>
                </div>
              </div>
              <div class="form-group row">
                <div class="col-sm-12">
                  <label for="inputs_editor">
                    {{ $t("description") }}
                  </label>
                  <app-input
                    type="text-editor"
                    :required="true"
                    id="text-editor-id"
                    :label="$t('message_placeholder')"
                    v-model="job.long_description"
                  />
                </div>
              </div>
              <div class="form-group row">
                <div class="col-sm-12">
                  <label for="inputs_editor">
                    {{ $t("notes") }}
                  </label>
                  <app-input
                    type="text-editor"
                    :required="true"
                    id="notes"
                    :label="$t('message_placeholder')"
                    v-model="job.notes"
                  />
                </div>
              </div>
              <div class="row">
                <div class="col-lg-12 col-md-12 col-sm-12">
                  <div class="form-group">
                    <app-input type="dropzone" v-model="dropzone_files" />
                    <small class="text-muted font-italic">
                      {{ $t("recommended_dropzone_file_validation") }}
                    </small>
                  </div>
                </div>
              </div>

              <div class="mt-5 action-buttons" style="text-align: end">
                <button
                  type="submit"
                  class="btn btn-primary mr-2"
                  @click.prevent="storeJob"
                >
                  {{ $t("submit") }}
                </button>
                <button
                  type="submit"
                  class="btn btn-secondary"
                  @click.prevent="clear"
                >
                  {{ $t("clear") }}
                </button>
              </div>
            </form>
          </div>
          
        </div>
      </div>
    </div>
    <category-addmodal
        v-if="isAddModalActive"
        @close-modal="closeCategory"
    />
    <dropdown-addmodal
        v-if="isDropdownAddModalActive"
        :type="dropdownType"
        @close-modal="closeDropdown"
    />
  </div>
</template>

<script>
import {FormMixin} from "../../../../../../core/mixins/form/FormMixin.js";
import {CATEGORIES, DROPDOWN,} from "../../../../../Config/ApiUrl.js";
import {axiosGet} from "../../../../../Helpers/AxiosHelper.js";
import AppLibrary from "../../../../../Helpers/AppLibrary";
import { textEditorHints } from "@/app/Helpers/Helpers";

export default {
  name: "job-create",
  extends: AppLibrary,
  mixins: [FormMixin],
  props: {
    refresh: Function,
    customerCompanyId: Number,
    isHideActions: {type: Boolean, default: false},
    isTemplateJob: {type: Boolean, default: false},
  },
  data() {
    return {
      isAddModalActive: false,
      isDropdownAddModalActive: false,
      dropdownType: '',
      preloader: false,
      job: {
        start_date: new Date(),
        end_date: new Date(),
      },
      // site: [],
      // task: [],
      // seen: false,
      dropzone_files: [],
      category: [],
      regionlist: [],
      threshold: [],
      framework: [],
      noticetypelist: [],
      bidRangeList: [],
      jobTypeList: [
        { id: "", value: "Choose One" },
        { id: "On-site", value: "On-site" },
        { id: "Hybrid", value: "Hybrid" },
        { id: "Remote", value: "Remote" },
      ],
      is_private: [
        { id: "", value: "Choose One" },
        { id: "0", value: "Public" },
        { id: "1", value: "Private" },
      ],
      status: [],
    };
  },
  created() {
      this.status = this.isTemplateJob ? [{ id: "job-template", value: "Template Job" }] : [
        { id: "", value: "Choose One" },
        { id: "draft", value: "Draft" },
        { id: "active", value: "Active" },
        { id: "job-template", value: "Template Job" },
      ]
  },
  methods: {
    addDropdown(type) {
      this.dropdownType = type;
      this.isDropdownAddModalActive = true;
    },
    closeDropdown() {
      $("#dropdown-add-Modal").modal('hide');
      this.isDropdownAddModalActive = false;
      this.dropdownType = '';
      this.getDropdown();
    },
    addCategory() {
      this.isAddModalActive = true;
    },
    closeCategory() {
      $("#demo-add-edit-Modal").modal('hide');
      this.isAddModalActive = false;
      this.getCategories();
    },

    submit() {
      if (this.customerCompanyId){
       this.inputs.company_id =  this.customerCompanyId;
      }
      this.save(this.inputs);
    },

    clear() {
      this.inputs = {};
      this.fieldStatus = {
        isSubmit: false,
      };
    },
    // addNewSite() {
    //   this.addSite();
    // },
    // popSite(index) {
    //   this.site.splice(index, 1);
    // },
    beforeSubmit() {
      this.preloader = true;
    },
    storeJob() {
      // this.seen = true;
      if (this.job.start_date)
        this.job.start_date = this.getDateFormatForBackend(this.job.start_date);
      if (this.job.end_date)
        this.job.end_date = this.getDateFormatForBackend(this.job.end_date);
      if(this.customerCompanyId)
        this.job.company_id = this.customerCompanyId;
      let formData = new FormData();
      if (this.dropzone_files.length) {
        this.dropzone_files.forEach((dropzone_file) => {
          formData.append(`dropzone_file[]`, dropzone_file);
        });
      }
      Object.keys(this.job).forEach((key) => {
        formData.append(key, this.job[key]);
      });
      this.save(formData);
      // axiosPost(COMPANY_JOB_STORE, this.job)
      //   .then((res) => {
      //     this.job.id = res.data.job_id;
      //     this.$toastr.s(res.data.message);
      //     this.job = {};
      //     window.location = "/buyer/job";
      //     // this.addSite();
      //   })
      //   .catch((error) => {
      //     this.$toastr.e(error.message);
      //     
      //   });
    },
    afterSuccess(res) {
      this.$toastr.s(res.data.message);
      this.job.id = res.data.job_id;
      // this.$toastr.s(res.data.message);
      this.job = {};
      // window.location = "/buyer/job";
      if(this.refresh) {
        this.refresh(1)
      }
      else {
        window.location = "/buyer/job";
      }
    },
    afterFinalResponse() {
      this.preloader = false;
      this.inputs = {};
    },
    afterError(res) {
      this.$toastr.e(res.data.message);
    },
    getCategories() {
      axiosGet(CATEGORIES)
        .then((res) => {
          this.category = res.data;
        })
        .catch((error) => {
          
        });
    },
    getDropdown() {
      axiosGet(DROPDOWN)
        .then((res) => {
          this.noticetypelist = res.data.notice ?? { id: "", value: "Choose One" };
          this.regionlist = res.data.region ?? { id: "", value: "Choose One" };
          this.threshold = res.data.threshold ?? { id: "", value: "Choose One" };
          this.framework = res.data.framework ?? { id: "", value: "Choose One" };
          this.bidRangeList = res.data.range ?? { id: "", value: "Choose One" };
        })
        .catch((error) => {
          
        });
    },
    // addNewTask(id) {
    //   this.addTask(id);
    // },
    // storeSite() {
    //   axiosPost(COMPANY_JOB_SITE_STORE, this.site)
    //     .then((res) => {
    //       
    //     })
    //     .catch((errors) => {
    //       
    //     });
    // },
    // addSite() {
    //   this.site.push({
    //     job_id: this.job.id,
    //     title: "",
    //     description: "",
    //     start_time: "",
    //     end_time: "",
    //     task: [],
    //   });
    // },

    // addTask(id) {
    //   this.site[id].task.push({
    //     title: "",
    //     description: "",
    //   });
    // },
  },
  mounted() {
    this.getCategories();
    this.getDropdown();
  },
};
</script>
